import { h } from "../../../_snowpack/pkg/preact.js";
import { useEffect, useRef, useState } from "../../../_snowpack/pkg/preact/hooks.js";
export const ShowInfoButton = () => {
  const buttonRef = useRef(null);
  const modalRef = useRef(null);
  const [infoIsVisible, setInfoIsVisible] = useState(false);
  useEffect(() => {
    const handleEscape = e => {
      if (e.key === "Escape") setInfoIsVisible(false);
    };

    const handleClickOutside = event => {
      if (buttonRef.current && modalRef.current && !modalRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        setInfoIsVisible(false);
      }
    };

    if (infoIsVisible) {
      document.addEventListener("keydown", handleEscape);
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [modalRef, infoIsVisible]);
  return h("div", null, infoIsVisible && h("div", {
    ref: modalRef,
    className: "uiButton modal infoModal",
    "aria-describedBy": "infoButton",
    hidden: !infoIsVisible
  }, h("p", null, "a scifi-inspired study of signed distanced functions and noise fields in webgl, by", " ", h("a", {
    href: "https://neef.co",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "neef rehman"), "."), h("p", null, "open source on", " ", h("a", {
    href: "https://github.com/neefrehman/manyworlds",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "github"), ".")), h("button", {
    ref: buttonRef,
    id: "infoButton",
    className: "uiButton infoButton",
    "aria-label": "info",
    "aria-expanded": infoIsVisible,
    tabIndex: 0,
    onClick: () => setInfoIsVisible(previnfoIsVisible => !previnfoIsVisible)
  }, h("span", {
    role: "tooltip"
  }, infoIsVisible ? "x" : "i")));
};